addEventListener("DOMContentLoaded", () => {
  if (!location.pathname.startsWith("/pages/shopping-guide")) {
    return;
  }
  document.documentElement.classList.add("fs-smooth-scroll");
});
